import { IVdoHttpErrorDetails } from './vdo-http-error-details.interface';

export class VdoHttpError extends Error {
  error!: IVdoHttpErrorDetails;

  constructor(m: IVdoHttpErrorDetails) {
    super(m.detail);

    Object.setPrototypeOf(this, VdoHttpError.prototype);
  }
}
